export default {
      id: "vague-usage",
      viewBox: "0 0 3090 1296",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#vague-usage",
      toString: function () {
        return this.url;
      }
    }